var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.isAlertOpen && this.countNewVibans > 0
            ? _c("alert-modal", [
                _c("span", [
                  _c("i", { staticClass: "fa-solid fa-circle-check" }),
                  _vm._v("Exported " + _vm._s(this.countExported) + " records"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content bg-light" }, [
            _c(
              "div",
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-title" },
                      [
                        _c("b-row", [_c("h1", [_vm._v("VIBAN Management")])]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("span", [
                            _vm._v("Manage virtual IBAN pool and allocations"),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "stats" },
                      _vm._l(_vm.stats, function (stat, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                stat.status != null
                                  ? _vm.selectStatus(stat.status)
                                  : ""
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", { style: { color: stat.color } }, [
                                _vm._v(_vm._s(stat.number)),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(stat.title))]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filters" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "filters-items" },
                      [
                        _c("div", { staticClass: "filter-item" }, [
                          _c("span", { staticClass: "filter-item-title" }, [
                            _vm._v("Search VIBAN"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              type: "text",
                              placeholder:
                                "Search by VIBAN or client number...",
                            },
                            on: {
                              input: function (event) {
                                return (
                                  (_vm.paginationObj.search = _vm.sanitize(
                                    event.target.value
                                  )),
                                  _vm.submit()
                                )
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submit()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                },
                                [_vm._v("Status Filter")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: {
                                    id: "status-picker-link",
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fixed-span-size" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.paginationObj.status == null ||
                                              this.paginationObj.status == "all"
                                              ? "All Statuses"
                                              : _vm.statusList.filter(function (
                                                  item
                                                ) {
                                                  if (
                                                    item.code ==
                                                    this$1.paginationObj.status
                                                  ) {
                                                    return item
                                                  }
                                                })[0].label
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "action-type-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "status-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.statusList,
                                      function (status, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            class: [
                                              "popover-option",
                                              {
                                                "popover-option-selected":
                                                  status.code == "all"
                                                    ? _vm.paginationObj
                                                        .status == null
                                                    : status.code ==
                                                      _vm.paginationObj.status,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectStatus(
                                                  status.code
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(status.label) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                },
                                [_vm._v("Country Filter")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: {
                                    id: "country-picker-link",
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fixed-span-size" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.paginationObj.country ==
                                              null ||
                                              this.paginationObj.country ==
                                                "all"
                                              ? "All Countries"
                                              : _vm.countryList.filter(
                                                  function (item) {
                                                    if (
                                                      item.code ==
                                                      this$1.paginationObj
                                                        .country
                                                    ) {
                                                      return item
                                                    }
                                                  }
                                                )[0].label
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "action-type-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "country-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.countryList,
                                      function (country, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            class: [
                                              "popover-option",
                                              {
                                                "popover-option-selected":
                                                  country.code ==
                                                  _vm.paginationObj.country,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectCountry(
                                                  country.code
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(country.label) +
                                                " " +
                                                _vm._s(
                                                  country.code != null
                                                    ? "(" + country.code + ")"
                                                    : ""
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "filter-item-title text-ellipsis",
                              },
                              [_vm._v("Per Page")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "filter-item-content d-flex justify-content-between py-2 px-3",
                                attrs: {
                                  id: "pagination-picker-link",
                                  href: "#",
                                },
                              },
                              [
                                _c("span", { staticClass: "fixed-span-size" }, [
                                  _vm._v(_vm._s(this.paginationObj.maxResults)),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-light fa-chevron-down",
                                  attrs: { size: "17px", id: "page-chevron" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "pagination-picker-link",
                                  triggers: "focus",
                                  placement: "bottom",
                                  "custom-class": "popover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(
                                    [10, 20, 30, 40, 50],
                                    function (resultsPerPage, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: [
                                            "popover-option",
                                            {
                                              "popover-option-selected":
                                                resultsPerPage ==
                                                _vm.paginationObj.maxResults,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectPagination(
                                                resultsPerPage
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(resultsPerPage) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between",
                          "padding-right": "1rem",
                        },
                      },
                      [
                        _c("b-col", [
                          _vm.totalResultsFiltered > 0
                            ? _c("span", [
                                _vm._v(
                                  "Showing " +
                                    _vm._s(_vm.paginationObj.firstIndex) +
                                    " - " +
                                    _vm._s(
                                      _vm.paginationObj.status != null ||
                                        _vm.paginationObj.search != null ||
                                        _vm.paginationObj.country != null
                                        ? _vm.totalResultsFiltered <
                                          _vm.paginationObj.maxResults
                                          ? _vm.totalResultsFiltered
                                          : _vm.currentPage *
                                            _vm.paginationObj.maxResults
                                        : _vm.totalResults <
                                          _vm.paginationObj.maxResults
                                        ? _vm.totalResults
                                        : _vm.currentPage *
                                          _vm.paginationObj.maxResults
                                    ) +
                                    " of " +
                                    _vm._s(
                                      _vm.paginationObj.status != null ||
                                        _vm.paginationObj.search != null ||
                                        _vm.paginationObj.country != null
                                        ? _vm.totalResultsFiltered
                                        : _vm.totalResults
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "1rem",
                            },
                          },
                          [
                            _vm.selectedItems.length > 0
                              ? _c("span", { staticClass: "selected" }, [
                                  _vm._v(
                                    _vm._s(_vm.selectedItems.length) +
                                      " selected"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "clear",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearSelection()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-classic fa-xmark",
                                    }),
                                    _vm._v("Clear"),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-tertiary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportSelected()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v(
                                      "Export Selected (" +
                                        _vm._s(_vm.selectedItems.length) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportFiltered()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export Filtered"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportAll()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export All"),
                              ]
                            ),
                            _vm._v(" "),
                            _c("import-viban-modal", {
                              on: { "update:refresh": this.refresh },
                            }),
                            _vm._v(" "),
                            _c("allocate-viban-modal", {
                              on: { "update:refresh": this.refresh },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline btn-dark",
                                on: {
                                  click: function ($event) {
                                    return _vm.refresh()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class: [
                                    "fa-classic",
                                    "fa-arrows-rotate",
                                    { rotate: _vm.isLoading },
                                  ],
                                }),
                                _vm._v(
                                  "\n                Refresh\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.items != null
                  ? _c(
                      "div",
                      { staticClass: "card" },
                      [
                        _c("div", { staticClass: "p-6" }, [
                          _c("h2", [_vm._v("VIBAN Pool")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.totalResults) +
                                " VIBAN" +
                                _vm._s(_vm.totalResults > 1 ? "s" : "")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.totalResultsFiltered > 0
                          ? _c(
                              "div",
                              { staticStyle: { "overflow-x": "auto" } },
                              [
                                _c("b-table", {
                                  staticClass: "table-header-border",
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "primary-key": "id",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "head(checkbox)",
                                        fn: function () {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: "all",
                                                    name: "checkAll",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.selectAll(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "head(VIBAN)",
                                        fn: function () {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                "Virtual IBAN\n                  "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id: "info-viban-link",
                                                    href: "#",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-circle-question",
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target: "info-viban-link",
                                                  triggers: "hover",
                                                  placement: "bottom",
                                                  "custom-class":
                                                    "popover-info",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "Virtual IBAN (VIBAN)"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "A unique virtual account number allocated to a client number. All orders from the same client use the same VIBAN for payment routing and automatic reconciliation."
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "head(status)",
                                        fn: function () {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                "Status\n                  "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id: "info-status-link",
                                                    href: "#",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-circle-question",
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target: "info-status-link",
                                                  triggers: "hover",
                                                  placement: "bottom",
                                                  "custom-class":
                                                    "popover-info",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v("VIBAN Status"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "Available: Ready for allocation. Allocated: In active use by a client. Deactivated: No longer in use but preserved for history."
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "head(allocationdate)",
                                        fn: function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleOrder()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v("Allocation Date "),
                                                _c("i", {
                                                  class: [
                                                    "fa-regular",
                                                    {
                                                      "fa-chevron-down":
                                                        _vm.paginationObj
                                                          .sortOrder == "asc",
                                                      "fa-chevron-up":
                                                        _vm.paginationObj
                                                          .sortOrder ==
                                                          "desc" ||
                                                        _vm.paginationObj
                                                          .sortOrder == null,
                                                    },
                                                  ],
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "cell(checkbox)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: data.item,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.toggleSelection(
                                                        $event,
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(country)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "btn-empty" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    data.item.VIBAN.substring(
                                                      0,
                                                      2
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(status)",
                                        fn: function (data) {
                                          return [
                                            data.item.Status == 0
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                    style: {
                                                      color: "#008236",
                                                      "background-color":
                                                        "#f0fdf4",
                                                      "border-color": "#b9f8cf",
                                                    },
                                                  },
                                                  [_vm._v("Available")]
                                                )
                                              : data.item.Status == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                  },
                                                  [_vm._v("Assigned")]
                                                )
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                    style: {
                                                      color: "#c10007",
                                                      "background-color":
                                                        "#fef2f2",
                                                      "border-color": "#ffc9c9",
                                                    },
                                                  },
                                                  [_vm._v("Frozen")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(clientnumber)",
                                        fn: function (data) {
                                          return [
                                            data.item.Reference1 != ""
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.item.Reference1)
                                                  ),
                                                ])
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "normal",
                                                    },
                                                  },
                                                  [_vm._v("—")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(allocationdate)",
                                        fn: function (data) {
                                          return [
                                            data.item.Date != ""
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      new Date(
                                                        Date.parse(
                                                          data.item.Date
                                                        )
                                                      ).toLocaleDateString("fr")
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.item.Date != ""
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                      "font-size": "0.9rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        new Date(
                                                          Date.parse(
                                                            data.item.Date
                                                          )
                                                        ).toLocaleTimeString(
                                                          "it-IT"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(actions)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex",
                                                staticStyle: {
                                                  gap: "0.5rem",
                                                  "justify-content": "center",
                                                },
                                              },
                                              [
                                                Number(data.item.Status) === 1
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-outline-light",
                                                        attrs: {
                                                          id:
                                                            "deallocate-link-" +
                                                            data.index,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deallocateViban(
                                                              data.item.IdGroup
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-regular fa-unlock",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                Number(data.item.Status) === 1
                                                  ? _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          target:
                                                            "deallocate-link-" +
                                                            data.index,
                                                          triggers: "hover",
                                                          placement: "top",
                                                          "custom-class":
                                                            "popover-btn",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Deallocate VIBAN\n                  "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-outline-light",
                                                    attrs: {
                                                      id:
                                                        "freeze-link-" +
                                                        data.index,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.updateStatus(
                                                          data.item.VIBAN,
                                                          Number(
                                                            data.item.Status
                                                          ) === 2
                                                            ? 0
                                                            : 1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "fa-regular",
                                                        data.item.Status === 2
                                                          ? "fa-unlock"
                                                          : "fa-lock",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      target:
                                                        "freeze-link-" +
                                                        data.index,
                                                      triggers: "hover",
                                                      placement: "top",
                                                      "custom-class":
                                                        "popover-btn",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          Number(
                                                            data.item.Status
                                                          ) === 2
                                                            ? "Unfreeze VIBAN"
                                                            : "Freeze VIBAN"
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-outline-light",
                                                    attrs: {
                                                      id:
                                                        "transaction-link-" +
                                                        data.index,
                                                      title:
                                                        "View Transactions",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navigate(
                                                          "/transactionledger/" +
                                                            data.item.VIBAN
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-regular fa-arrow-up-right-from-square",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      target:
                                                        "transaction-link-" +
                                                        data.index,
                                                      triggers: "hover",
                                                      placement: "top",
                                                      "custom-class":
                                                        "popover-btn",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    View Transactions\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1064166637
                                  ),
                                }),
                                _vm._v(" "),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.totalResultsFiltered > 0
                          ? _c("b-row", { staticClass: "pagination" }, [
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    { inactive: _vm.currentPage == 1 },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage > 1 && _vm.previous()
                                    },
                                  },
                                },
                                [_vm._v("Previous")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Page " +
                                    _vm._s(_vm.currentPage) +
                                    " of " +
                                    _vm._s(_vm.totalPages)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    {
                                      inactive:
                                        _vm.currentPage == _vm.totalPages,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage < _vm.totalPages &&
                                        _vm.next()
                                    },
                                  },
                                },
                                [_vm._v("Next")]
                              ),
                            ])
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  margin: "1rem",
                                  color: "#969696",
                                  display: "flex",
                                  "justify-content": "center",
                                },
                              },
                              [_c("span", [_vm._v("No results found")])]
                            ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "card empty" },
                      [_c("b-spinner", { attrs: { label: "Loading..." } })],
                      1
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }